import Router from "./router/router";
import "./App.module.scss";
import Licence from "./views/Licence/Licence";

function App() {
	return (
		<div className="App">
			<Router />
			{/* <Licence /> */}
		</div>
	);
}

export default App;
